// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  treatyId: __t.u64().primaryKey().name("treaty_id"),
  civA: __t.string().name("civ_a"),
  civB: __t.string().name("civ_b"),
  kind: __t.string(),
  state: __t.string(),
  proposedBy: __t.string().name("proposed_by"),
  fromCyc: __t.u64().name("from_cyc"),
  untilCyc: __t.u64().name("until_cyc"),
  breachedBy: __t.string().name("breached_by"),
  breachedCyc: __t.u64().name("breached_cyc"),
  updatedAt: __t.timestamp().name("updated_at"),
});
